var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Bar from "ol-ext/control/Bar";
import Charon from "../apis/charon";
import JobLayer from "./jobLayer";
import SelectionLayer from "./selectionLayer";
import View from "ol/View";
import { Attribution, Zoom } from "ol/control";
import { Select } from "ol/interaction";
import { boundingExtent, containsExtent } from "ol/extent";
import { filterJobs } from "./geometryFilter";
import { fromLonLat, transform, transformExtent } from "ol/proj";
import { Map, } from "ol";
import { globalStore } from "../state/store";
import { degrees2meters } from "./util";
import CircleLayer from "./circleLayer";
import { fromExtent } from "ol/geom/Polygon";
import { OSMLayer } from "../apis/tileLayers";
import { Style } from "ol/style";
import CircleStyle from "ol/style/Circle";
export default class Atlas {
    constructor(mapID, opts) {
        this.mapID = mapID;
        this.zIndices = {
            tiles: 0,
            countries: 10,
            circleSelect: 10,
            jobs: 500,
        };
        this.map = this.build(opts || {});
        this.addSelectionLayer();
        this.addCircleLayer();
        this.addControls();
        this.buildJobLayer();
        this.addVisibleJobsHook();
        this.addGeometriesHook();
        this.addJobFilterHook();
        this.addSelect();
    }
    subscribe(hooks, callback) {
        globalStore.events.subscribe(hooks, callback);
    }
    radiusSearch(query, radius) {
        return __awaiter(this, void 0, void 0, function* () {
            const geojson = yield new Charon().forwardGeocoding(query);
            if (geojson === undefined) {
                console.error("Could not find " + query);
                return;
            }
            let latlon = geojson.features[0].geometry.coordinates;
            let coordinate = degrees2meters(latlon[0], latlon[1]);
            this.circleLayer.setCircle(coordinate, radius * 1000);
            this.circleLayer.circleAddModify(this);
            setTimeout(() => {
                this.map.getView().fit(this.circleLayer.getCircle().getExtent(), { padding: [150, 50, 100, 100], duration: 1000, maxZoom: 19 });
            }, 500);
        });
    }
    zoomTo(center, zoom = 16) {
        this.map.getView().animate({
            center: center,
            zoom: zoom,
            duration: 1200
        });
    }
    addSelect() {
        const select = new Select({
            layers: [this.JobLayer.animatedCluster],
            style: new Style({
                image: new CircleStyle({
                    radius: 0,
                }),
            })
        });
        this.map.addInteraction(select);
        select.on("select", (e) => {
            var selectedFeatures = select.getFeatures();
            selectedFeatures.forEach((f) => {
                const clickedClusters = f.get("features");
                const clickedLoc = clickedClusters.map((f) => f.get("job"));
                globalStore.dispatch("setJobLocation", globalStore.getState().jobLocations);
                globalStore.dispatch("setSelectedLocation", clickedLoc);
            });
        });
    }
    addVisibleJobsHook() {
        globalStore.events.subscribe(["STATE_CHANGE_JOBLOCATIONS", "STATE_CHANGE_VISIBLEJOBS"], (state) => {
            this.JobLayer.setJobs(state.jobLocations);
        });
    }
    addGeometriesHook() {
        globalStore.events.subscribe(["STATE_CHANGE_SELECTEDGEOMETRIES", "STATE_CHANGE_ALLJOBS"], (state) => {
            this.selectionLayer.setVisibleFeatures(state.selectedGeometries);
        });
    }
    addJobFilterHook() {
        globalStore.events.subscribe(["STATE_CHANGE_ALLJOBS", "STATE_CHANGE_SELECTEDGEOMETRIES"], (state) => {
            let newShownJobs = [];
            let newShownLocation = [];
            if (globalStore.getState().selectedGeometries.length === 0) {
                newShownJobs = state.allJobs;
                newShownLocation = state.jobLocationsAll;
            }
            else {
                newShownJobs = filterJobs(state.allJobs, {
                    geometries: state.selectedGeometries,
                });
                for (let i = 0; i < state.jobLocationsAll.length; i++) {
                    for (let j = 0; j < newShownJobs.length; j++) {
                        if (state.jobLocationsAll[i].IDs.includes(newShownJobs[j].id.toString()) && !newShownLocation.includes(state.jobLocationsAll[i])) {
                            newShownLocation.push(state.jobLocationsAll[i]);
                        }
                    }
                }
            }
            globalStore.dispatch("setVisibleJobs", newShownJobs);
        });
    }
    addLayer(layer, opts = {}) {
        const { name = "", overwrite = false } = opts;
        if (this.map.getLayers().getArray().indexOf(layer) === -1 || overwrite) {
            if (name !== "") {
                layer.set("name", name);
            }
            this.map.addLayer(layer);
        }
    }
    addControls() {
        const mainbar = new Bar();
        mainbar.setPosition("bottom");
        this.map.addControl(mainbar);
        return mainbar;
    }
    addCircleLayer() {
        this.circleLayer = new CircleLayer();
        this.map.addLayer(this.circleLayer.getCircleLayer());
        this.circleLayer.circleAddModify(this);
    }
    addSelectionLayer() {
        this.selectionLayer = new SelectionLayer();
        this.map.addLayer(this.selectionLayer);
    }
    createView(opts) {
        if (opts.view) {
            return new View({
                center: fromLonLat([opts.view.lon, opts.view.lat]),
                zoom: opts.view.zoom,
            });
        }
        else if (opts.extent) {
            const view = new View();
            view.fit(opts.extent);
            return view;
        }
        else {
            return new View({
                center: fromLonLat([0, 45]),
                minZoom: 2,
                zoom: 2,
                extent: [-19000000.64651901, -20037508.342789244, 22000000.849054288, 20037508.342789244]
            });
        }
    }
    build(opts) {
        const charonRasterLayer = new OSMLayer().getLayer();
        const controls = [
            new Attribution({
                collapsible: false,
            }),
            new Zoom(),
        ];
        const map = new Map({
            target: this.mapID,
            controls: controls,
            view: this.createView(opts),
        });
        this.map = map;
        this.addLayer(charonRasterLayer, { name: "rasterTiles" });
        return map;
    }
    buildJobLayer() {
        this.JobLayer = new JobLayer(60);
        this.JobLayer.animatedCluster.setZIndex(this.zIndices.jobs);
        this.addLayer(this.JobLayer.animatedCluster, { name: "cluster" });
    }
    zoomToBuildedExtent(coordinates) {
        const extent = transformExtent(boundingExtent(coordinates), "EPSG:4326", "EPSG:3857");
        this.map.getView().fit(extent, { duration: 1000, maxZoom: 19 });
    }
    filterJobsOnMap(extent) {
        return __awaiter(this, void 0, void 0, function* () {
            let newShownJobs = [];
            let state = globalStore.getState();
            if (globalStore.getState().selectedGeometries.length === 0) {
                newShownJobs = state.allJobs;
            }
            else {
                newShownJobs = filterJobs(state.allJobs, {
                    geometries: state.selectedGeometries,
                });
            }
            newShownJobs = filterJobs(newShownJobs, {
                geometries: [fromExtent(extent)],
            });
            globalStore.dispatch("setVisibleJobs", newShownJobs);
        });
    }
    isSpotlightVisible() {
        if (this.spotLight != undefined) {
            return containsExtent(this.getExtent(), this.spotLight.getExtent());
        }
        else {
            return true;
        }
    }
    getZoom() {
        return this.map.getView().getZoom();
    }
    getCenter() {
        return transform(this.map.getView().getCenter(), this.map.getView().getProjection(), 'EPSG:4326');
    }
    getSelectedJobs() {
        return globalStore.getState().selectedJobs;
    }
    getVisibleJobs() {
        return globalStore.getState().visibleJobs;
    }
    getExtent() {
        return this.map.getView().calculateExtent();
    }
    removeRadiusCircle() {
        this.circleLayer.resetCircleLayer();
    }
}
